// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2895eb66d80d90acc7d37e7e5c247214c5c0dc87/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};